/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { healthCheckControllerHealthCheckV1 } from '../fn/health-check/health-check-controller-health-check-v-1';
import { HealthCheckControllerHealthCheckV1$Params } from '../fn/health-check/health-check-controller-health-check-v-1';

@Injectable({ providedIn: 'root' })
export class HealthCheckService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `healthCheckControllerHealthCheckV1()` */
  static readonly HealthCheckControllerHealthCheckV1Path = '/api/v1/health-check';

  /**
   * 헬스 체크.
   *
   * DB 연결 확인
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healthCheckControllerHealthCheckV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthCheckControllerHealthCheckV1$Response(params?: HealthCheckControllerHealthCheckV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return healthCheckControllerHealthCheckV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 헬스 체크.
   *
   * DB 연결 확인
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `healthCheckControllerHealthCheckV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthCheckControllerHealthCheckV1(params?: HealthCheckControllerHealthCheckV1$Params, context?: HttpContext): Observable<boolean> {
    return this.healthCheckControllerHealthCheckV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
